import { render } from "./FlashMessage.vue?vue&type=template&id=8bc5bcf2"
import script from "./FlashMessage.vue?vue&type=script&lang=js"
export * from "./FlashMessage.vue?vue&type=script&lang=js"

import "./FlashMessage.vue?vue&type=style&index=0&id=8bc5bcf2&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__